import React from 'react';
import { Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface MedNecDashboardBackButtonProps {
  company: string;
  center: string;
  label?: string;
  sx?: object;
}

const MedNecDashboardBackButton: React.FC<MedNecDashboardBackButtonProps> = ({
  company,
  center,
  label = 'Back to Dashboard',
  sx = {}
}) => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    const params = new URLSearchParams();
    if (company) params.append('company', company);
    if (center) params.append('center', center);

    navigate(`/mednec?${params.toString()}`);
  };

  return (
    <Button
      variant="outlined"
      onClick={handleBackToDashboard}
      startIcon={<ArrowBackIcon />}
      sx={{
        color: '#64748b',
        borderColor: '#e2e8f0',
        fontWeight: 600,
        px: 3,
        py: 1,
        '&:hover': {
          backgroundColor: '#f8fafc',
          borderColor: '#cbd5e1'
        },
        ...sx
      }}
    >
      {label}
    </Button>
  );
};

export default MedNecDashboardBackButton;
